import { connect } from 'react-redux';
import CTViewerRetrieveStudyData from './CTViewerRetrieveStudyData';
const isActive = a => a.active === true;
const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  return { server: activeServer };
};

const ConnectedCTViewerRetrieveStudyData = connect(
  mapStateToProps,
  null
)(CTViewerRetrieveStudyData);

export default ConnectedCTViewerRetrieveStudyData;
